import { render, staticRenderFns } from "./WidgetAnchor.vue?vue&type=template&id=218ad45a"
import script from "./WidgetAnchor.vue?vue&type=script&lang=js"
export * from "./WidgetAnchor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports